import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

import { AppStatusSwitchProps } from "./types";

const AppStatusSwitch = ({
  checked,
  loading = false,
  activeLabel = "Active",
  inactiveLabel = "Inactive",
  showLabel = true,
  onChange,
  ...props
}: AppStatusSwitchProps) => {
  if (loading) {
    return <CircularProgress size={20} />;
  }

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
    >
      <Switch
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        color="success"
        {...props}
      />

      {showLabel && (
        <Typography
          variant="body2"
          fontWeight={600}
          color={checked ? "success.main" : "text.secondary"}
        >
          {checked ? activeLabel : inactiveLabel}
        </Typography>
      )}
    </Stack>
  );
};

export default AppStatusSwitch;
